var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnX(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1114.245 -1931.245)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 69",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "translate(1114.245 1931.245)",
    style: {
      fill: "#1f1852"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 12364"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 14",
    transform: "translate(1120.245 1937.245)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "1.5px"
    },
    d: "M7 0 0 7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 15",
    transform: "translate(1120.245 1937.245)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "1.5px"
    },
    d: "m0 0 7 7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnX);
export default __webpack_public_path__ + "static/media/btn_x.a9220cd0ce340901dcb83676c4e88c87.svg";
export { ForwardRef as ReactComponent };